import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b441c204")

_pushScopeId("data-v-b441c204")
const _hoisted_1 = { class: "shift-being-confirm" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "font-bold mb-2 mt-6" }
const _hoisted_4 = { class: "mb-7 mt-6 font-size-18" }
const _hoisted_5 = { class: "flex mb-4 items-center" }
const _hoisted_6 = { class: "w-48 text-right mr-8" }
const _hoisted_7 = { class: "w-104 fz-24" }
const _hoisted_8 = { class: "flex mb-4 items-center" }
const _hoisted_9 = { class: "w-48 text-right mr-8" }
const _hoisted_10 = { class: "w-64 fz-24" }
const _hoisted_11 = { class: "flex mb-4 items-center" }
const _hoisted_12 = { class: "w-48 text-right mr-8" }
const _hoisted_13 = { class: "flex items-center justify-between" }
const _hoisted_14 = { class: "mr-10 fz-24" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", null, "～", -1)
const _hoisted_16 = { class: "ml-10 fz-24" }
const _hoisted_17 = { class: "flex mb-4" }
const _hoisted_18 = { class: "w-48 text-right mr-8 mt-3" }
const _hoisted_19 = { class: "mb-3 flex-column" }
const _hoisted_20 = { class: "inline-flex mb-2" }
const _hoisted_21 = { class: "inline-flex items-center mr-10" }
const _hoisted_22 = { class: "mr-datepicker fz-16" }
const _hoisted_23 = { class: "inline-flex items-center" }
const _hoisted_24 = { class: "mr-datepicker fz-16" }
const _hoisted_25 = { class: "flex mb-10" }
const _hoisted_26 = { class: "w-full" }
const _hoisted_27 = { class: "mb-4" }
const _hoisted_28 = { class: "mb-3 font-size-18" }
const _hoisted_29 = { class: "flex justify-center" }
const _hoisted_30 = { class: "w-1/4 flex justify-center mx-3" }
const _hoisted_31 = { class: "box-avatar" }
const _hoisted_32 = { class: "box-avatar__code font-size-12" }
const _hoisted_33 = { class: "flex justify-center span-action--active deadline-to-send" }
const _hoisted_34 = { class: "flex justify-center span-action--active" }
const _hoisted_35 = { class: "flex justify-center span-action--active" }
const _hoisted_36 = { class: "mt-8 flex justify-center" }
const _hoisted_37 = { class: "mr-16" }
const _hoisted_38 = { class: "mr-16" }
const _hoisted_39 = {
  style: {"min-width":"360px","height":"320px"},
  class: "flex flex-column justify-center mx-10"
}
const _hoisted_40 = { class: "fz-30 font-bold text-grey-3" }
const _hoisted_41 = { class: "flex justify-around mt-20" }
const _hoisted_42 = { class: "flex justify-center" }
const _hoisted_43 = { class: "flex justify-center" }
const _hoisted_44 = {
  style: {"min-width":"360px","height":"320px"},
  class: "flex flex-column justify-center mx-10"
}
const _hoisted_45 = { class: "flex flex-column align-items-center" }
const _hoisted_46 = { class: "fz-30 font-bold flex justify-center text-grey-3 mb-5" }
const _hoisted_47 = {
  class: "fz-20 font-bold text-center text-red-ff",
  style: {"max-width":"260px"}
}
const _hoisted_48 = { class: "flex justify-around mt-20" }
const _hoisted_49 = { class: "flex justify-center" }
const _hoisted_50 = { class: "flex justify-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Table = _resolveComponent("Table")
  const _component_Button = _resolveComponent("Button")
  const _component_Popup = _resolveComponent("Popup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('newShiftPlan')), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('shiftPlanName')), 1),
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.formData.shift_plan_name), 1)
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.t('departmentToBeShifted')), 1),
        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.formData.unit_name), 1)
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, _toDisplayString(_ctx.t('creationTargetPeriod')), 1),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, _toDisplayString(_ctx.moment(_ctx.formData.register_start_date).format(_ctx.DATE_FORMAT)) + " " + _toDisplayString(`(${_ctx.optionDays[_ctx.moment.utc(_ctx.formData.register_start_date).day()]}) `), 1),
          _hoisted_15,
          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.moment(_ctx.formData.register_end_date).format(_ctx.DATE_FORMAT)) + " " + _toDisplayString(`(${_ctx.optionDays[_ctx.moment.utc(_ctx.formData.register_end_date).day()]}) `), 1)
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, _toDisplayString(_ctx.t('confirmShift.deadlineForSubmit')), 1),
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode("label", _hoisted_21, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.submit_desired_shift_type = $event)),
                value: 0,
                name: "deadlineForSubmit",
                type: "radio",
                disabled: _ctx.statusNewShift === _ctx.ITEM_STATUS,
                class: "h-4 w-4 border-gray-300 focus:from-black mr-3 text-green-500 radio"
              }, null, 8, ["disabled"]), [
                [_vModelRadio, _ctx.formData.submit_desired_shift_type]
              ]),
              _createVNode("span", _hoisted_22, _toDisplayString(_ctx.t('confirmShift.submissionDeadline')), 1)
            ]),
            _createVNode(_component_DatePicker, {
              width: "184",
              modelValue: _ctx.formData.deadline,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.deadline = $event)),
              format: "YYYY/MM/DD",
              disabled: 
                _ctx.statusNewShift === _ctx.ITEM_STATUS ||
                _ctx.formData.submit_desired_shift_type === 1
              
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createVNode("label", _hoisted_23, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.submit_desired_shift_type = $event)),
              value: 1,
              name: "deadlineForSubmit",
              type: "radio",
              disabled: _ctx.statusNewShift === _ctx.ITEM_STATUS,
              class: "h-4 w-4 border-gray-300 focus:from-black mr-3 text-green-500 radio"
            }, null, 8, ["disabled"]), [
              [_vModelRadio, _ctx.formData.submit_desired_shift_type]
            ]),
            _createVNode("span", _hoisted_24, _toDisplayString(_ctx.t('confirmShift.submissionDeadlineIndividually')), 1)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_25, [
      _createVNode("div", _hoisted_26, [
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, _toDisplayString(_ctx.t('membersShifted')), 1),
          _createVNode(_component_Table, {
            class: "text-center",
            "fixed-header": "",
            "show-select": "",
            headers: _ctx.membersToBeShiftedHeaders,
            data: _ctx.membersToBeShiftedList,
            "selected-item": _ctx.membersToBeShiftedSelected,
            "onUpdate:selected-item": _cache[5] || (_cache[5] = ($event: any) => (_ctx.membersToBeShiftedSelected = $event)),
            fixedHeader: ""
          }, _createSlots({
            name: _withId(({ item }) => [
              _createVNode("div", {
                class: "flex items-center justify-start",
                onClick: ($event: any) => (_ctx.onClickName(item))
              }, [
                _createVNode("div", _hoisted_30, [
                  _createVNode(_component_Avatar, {
                    width: "40px",
                    height: "40px",
                    src: item.avatar,
                    class: "mr-2"
                  }, null, 8, ["src"])
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, _toDisplayString(item.name), 1)
                ])
              ], 8, ["onClick"])
            ]),
            deadlineToSend: _withId(({ item }) => [
              _createVNode("div", _hoisted_33, [
                (_ctx.formData.submit_desired_shift_type === 1)
                  ? (_openBlock(), _createBlock(_component_DatePicker, {
                      key: 0,
                      width: "184",
                      modelValue: item.deadline,
                      "onUpdate:modelValue": ($event: any) => (item.deadline = $event),
                      format: "YYYY/MM/DD",
                      disabled: _ctx.formData.submit_desired_shift_type !== 1
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.formData.submit_desired_shift_type !== 1)
                  ? (_openBlock(), _createBlock(_component_DatePicker, {
                      key: 1,
                      width: "184",
                      modelValue: _ctx.formData.deadline,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.deadline = $event)),
                      format: "YYYY/MM/DD",
                      disabled: _ctx.formData.submit_desired_shift_type !== 1
                    }, null, 8, ["modelValue", "disabled"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            sendShift: _withId(({ item, index }) => [
              _createVNode("div", _hoisted_34, [
                _createVNode("span", {
                  onClick: ($event: any) => (
                    _ctx.statusNewShift !== _ctx.ITEM_STATUS
                      ? _ctx.openPopupConfirmSendShift(item, index)
                      : ''
                  ),
                  class: ["cp-icon-send text-2xl hover:text-blue-600 cursor-pointer w-100", _ctx.statusNewShift === _ctx.ITEM_STATUS ? 'disable' : '']
                }, null, 10, ["onClick"])
              ])
            ]),
            removeAction: _withId(({ item, index }) => [
              _createVNode("div", _hoisted_35, [
                _createVNode("span", {
                  onClick: ($event: any) => (
                    _ctx.statusNewShift !== _ctx.ITEM_STATUS
                      ? _ctx.openPopupConfirmCancelShift(item, index)
                      : ''
                  ),
                  class: ["cp-icon-trash text-2xl hover:text-blue-600 cursor-pointer w-100", _ctx.statusNewShift === _ctx.ITEM_STATUS ? 'disable' : '']
                }, null, 10, ["onClick"])
              ])
            ]),
            _: 2
          }, [
            (_ctx.statusNewShift === _ctx.ITEM_STATUS)
              ? {
                  name: "checkbox",
                  fn: _withId(() => [
                    _createVNode("div", _hoisted_29, [
                      _createVNode(_component_Checkbox, {
                        disabled: _ctx.statusNewShift === _ctx.ITEM_STATUS
                      }, null, 8, ["disabled"])
                    ])
                  ])
                }
              : undefined
          ]), 1032, ["headers", "data", "selected-item"]),
          _createVNode("div", _hoisted_36, [
            _createVNode("div", _hoisted_37, [
              (_ctx.statusNewShift !== _ctx.ITEM_STATUS)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "h-12 w-50 font-bold text-white btn-save-creation",
                    disabled: _ctx.disableButtons,
                    onClick: _ctx.handleSendAllShift
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('bulkTransmission')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_38, [
              (_ctx.statusNewShift !== _ctx.ITEM_STATUS)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "h-12 w-50 font-bold text-white btn-cancel-creation",
                    onClick: _ctx.handleCancelAllShift,
                    disabled: _ctx.disableButtons
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('bulkCancellation')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"]))
                : _createCommentVNode("", true),
              (_ctx.statusNewShift === _ctx.ITEM_STATUS)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    class: "h-12 w-50 font-bold text-white btn-save-creation",
                    onClick: _ctx.handleReturn
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('returnScreen')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isShowPopupConfirmSendShift)
      ? (_openBlock(), _createBlock(_component_Popup, {
          key: 0,
          modelValue: _ctx.isShowPopupConfirmSendShift
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, _toDisplayString(_ctx.t('doyouwantSendAShiftSubRequest')), 1),
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _createVNode(_component_Button, {
                    class: "h-12 w-50 font-bold text-white btn-save-creation",
                    onClick: _ctx.sendShiftElement
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('send')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createVNode("div", _hoisted_43, [
                  _createVNode(_component_Button, {
                    class: "btn-gradation-secondary-7d w-50 h-12",
                    onClick: _ctx.closePopupConfirmSendShift
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('buttonCancel')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.isShowPopupConfirmCancelShift)
      ? (_openBlock(), _createBlock(_component_Popup, {
          key: 1,
          modelValue: _ctx.isShowPopupConfirmCancelShift
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_44, [
              _createVNode("div", _hoisted_45, [
                _createVNode("div", _hoisted_46, _toDisplayString(_ctx.t('confirmShift.titlePopupCancelShift')), 1),
                _createVNode("div", _hoisted_47, _toDisplayString(_ctx.t('confirmShift.subtitlePopupCancelShift')), 1)
              ]),
              _createVNode("div", _hoisted_48, [
                _createVNode("div", _hoisted_49, [
                  _createVNode(_component_Button, {
                    class: "h-12 w-50 font-bold text-white btn-cancel-creation cursor-pointer",
                    onClick: _ctx.cancelShiftElement,
                    disabled: _ctx.statusNewShift === _ctx.ITEM_STATUS
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('submissionRequestBtn')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ]),
                _createVNode("div", _hoisted_50, [
                  _createVNode(_component_Button, {
                    class: "btn-gradation-secondary-7d w-50 h-12 cursor-pointer",
                    onClick: _ctx.closePopupConfirmCancelShift,
                    disabled: _ctx.statusNewShift === _ctx.ITEM_STATUS
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('buttonCancel')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
})